import { useForm } from "react-hook-form";
import useRecoveryPassord from "../../api/hooks/password/useRecoveryPassword";
import Footer from "../../components/Footer";
import CustomInput from "../../components/inputs/CustomInput";
import FeedMessage from "../../components/misc/FeedMessage";
import { authInputs } from "../../consts/inputs";
import { toAssets, toIllustrations } from "../../consts/Paths";
import useIsMobile from "../../hooks/useIsMobile";
import useToggle from "../../hooks/useToggle";
import "../../styles/Access.css";
import "../../styles/General.css";
import { getInputs } from "../../utils/getMethods";
import { useEffect } from "react";
import useLogMessage from "../../hooks/useLogMessage";
import LogMessage from "../../components/misc/LogMessage";
import { logMsgBgColors } from "../../consts/misc";

const RecoveryPasswordPage = (props: any) => {
  const { isMobile } = useIsMobile();
  const { recoveryPasswordResponse, recoveryPasswordResult, recoveryPassword } =
    useRecoveryPassord();
  const { isToggled, message, write } = useLogMessage();

  const emailSent = useToggle(false);

  useEffect(() => {
    if (recoveryPasswordResponse?.ok) {
      emailSent.toggle();
    }
  }, [recoveryPasswordResponse]);

  const recoveryForm = useForm();
  const {
    formState: { errors },
  } = recoveryForm;

  const chosenInputs = getInputs(authInputs, ["email"]);
  const renderInputs = chosenInputs.map((input, key) => {
    return (
      <CustomInput
        key={key}
        {...input}
        register={recoveryForm.register}
        errors={errors}
      />
    );
  });

  const onSubmit = (data: any) => {
    /* console.log(data); */
    recoveryPassword(data.email);
  };

  useEffect(() => {
    /* console.log(recoveryPasswordResponse, recoveryPasswordResult); */
    if (recoveryPasswordResponse?.ok) {
    } else if (recoveryPasswordResponse?.ok === false) {
      write("subject", "Incorrect mail try again ");
      write("bgColor", logMsgBgColors.error);
    }
  }, [recoveryPasswordResponse]);

  return (
    <div className="access-background">
      <img className="Logo_2-POS4x" src={`${toAssets}/Logo_2-POS@4x.png`} />
      {emailSent.isToggled ? (
        <FeedMessage
          imageBgClassName="mailImage-background"
          imageSrc={`${toIllustrations}/email.svg`}
          title="Congratulations!"
          description={`We have sent an e-mail to ${recoveryForm.getValues(
            "email"
          )} with the link to reset your password`}
          link={{ path: "/login", text: "Go to Log In" }}
        />
      ) : (
        <div className={`access-content-box ${isMobile && "a-c-b-Mob"}`}>
          <div className="access-content-box-inner-wrapper">
            <form onSubmit={recoveryForm.handleSubmit(onSubmit)}>
              <div className="access-contentBox-header">
                <div className="cornerTitle">
                  {"Forgot Password"}
                  <p className="cornerSubTitle">
                    {"Enter the email you used to register"}
                  </p>
                </div>
              </div>
              <div style={{ marginTop: "32px" }}>
                <div style={{ marginTop: "-20px" }}>
                  {renderInputs}
                  {errors.email && (
                    <p className="errorInput">
                      {"Please provide a properly formatted e-mail address"}
                    </p>
                  )}
                </div>
              </div>
              <div
                className="contentBox-confirmationBox"
                style={{ marginTop: "50px" }}
              >
                <p
                  className="forgotpassword-link"
                  onClick={() => {
                    window.location.href = `/login`;
                  }}
                >
                  {"Back"}
                </p>
                <button className="button1 b-short" type="submit">
                  <p className="button1-text">{"Recover"}</p>
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      {isToggled && (
        <LogMessage
          text={{
            subject: message.subject,
            other_text: message.other_text,
            complement: message.complement,
          }}
          bgColor={message.bgColor}
        />
      )}
      <Footer />
    </div>
  );
};
export default RecoveryPasswordPage;
